import { useEffect } from "react";
import Grid from "@mui/material/Grid";

import ExportDataButton from "../../../common/components/button/ExportDataButton";
import AllLocationsEventsFilterDropdownContainer from "../../../common/components/locations/recent-events/AllLocationsEventsFilterDropdownContainer";
import EventSelect from "../../../common/components/select/EventSelect/EventSelect";
import {
  EVENTS_LOCATIONS_DROPDOWN_STORAGE_KEY,
  setLocationToLocalStorage,
} from "../../../common/helpers/getLocationFromLocalStorage";
import { AutocompleteOptionType } from "../../../common/models/autocomplete";
import { useAuthenticatedUser } from "../../../common/hooks/useAuthenticatedUser";
import { RoleEnum } from "../../../common/models/enums";
import { selectedLocationVariable } from "../../../common/variables/selectedLocation";
import {
  selectedModelVariable,
  useSelectedModel,
} from "../../../common/variables/selectedModel";
import { selectedDataHubLocationVariable } from "../../data-hub/components/dataHub.variable";
import useExportRecentEventsData from "../hooks/export/useExportRecentEventsData";

const RecentActivitiesFilters = () => {
  const { downloadRecentEventsData, loading } = useExportRecentEventsData();
  const { role } = useAuthenticatedUser();

  const selectedModel = useSelectedModel();
  const setSelectedModel = selectedModelVariable;

  const setSelectedLocation = selectedLocationVariable;

  // Auto-set gas leak for VERIFIER users
  const isVerifier = role === RoleEnum.VERIFIER;
  const gasLeakOption: AutocompleteOptionType = {
    title: "Gas leak",
    value: "GASLEAK",
  };

  // Set gas leak option for VERIFIER users if not already set
  useEffect(() => {
    if (isVerifier && (!selectedModel || selectedModel.value !== "GASLEAK")) {
      setSelectedModel(gasLeakOption);
    }
  }, [isVerifier, selectedModel, setSelectedModel, gasLeakOption]);

  const handleModelChange = (modelOption: AutocompleteOptionType | null) => {
    setSelectedModel(modelOption);
  };

  const handleLocationChange = (
    locationValue: AutocompleteOptionType | null
  ) => {
    setSelectedLocation(locationValue);

    // Update the selected for legacy Data Hub pages
    selectedDataHubLocationVariable(locationValue);

    setLocationToLocalStorage(
      EVENTS_LOCATIONS_DROPDOWN_STORAGE_KEY,
      locationValue
    );
  };

  const handleDownloadClick = async () => {
    try {
      await downloadRecentEventsData();
    } catch (error) {
      console.error("Error downloading data:", error);
    }
  };

  return (
    <Grid item xs={12} sm={6} display="flex" gap="16px">
      <ExportDataButton
        sx={{
          color: theme => theme.palette.text.primary,
          marginLeft: "26px",
          "&.Mui-disabled": {
            color: "inherit",
            backgroundColor: "transparent",
          },
        }}
        onClick={handleDownloadClick}
        loading={loading}
      >
        Export Data
      </ExportDataButton>
      <div style={{ flex: 1 }}>
        <AllLocationsEventsFilterDropdownContainer
          setLocation={handleLocationChange}
          ignoreDefaultValue
          disableFilteringByTags
        />
      </div>

      <div style={{ flex: 1 }}>
        <EventSelect value={selectedModel} onChange={handleModelChange} />
      </div>
    </Grid>
  );
};

export default RecentActivitiesFilters;
